import { DetailBlock as DetailBlockType, BlockAction } from '../../types/panel'
import BlockActions from './BlockActions'

interface Props { block: DetailBlockType; onAction?: (action: BlockAction) => void }

export default function DetailBlock({ block, onAction }: Props) {
  const fields = Array.isArray(block.fields) ? block.fields : []
  return (
    <div className="k-block">
      <h4 className="k-block__title">{block.title}</h4>
      <table className="k-detail">
        <tbody>
          {fields.map((f, i) => (
            <tr key={i}>
              <td className="k">{f.label}</td>
              <td className={(f.mono ? 'mono ' : '') + (f.tone ? `tone-${f.tone}` : '')}>
                {f.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <BlockActions actions={block.actions} onAction={onAction} />
    </div>
  )
}
